<template>
    <div class="home-wrap">
        <top-menu-bar />
        <side-menu-bar />
        <router-view />
    </div>
</template>

<script>
import TopMenuBar from '@/components/bars/TopMenuBar'
import SideMenuBar from '@/components/bars/SideMenuBar'

export default {
    name: 'HomePage',

    components: {
        TopMenuBar,
        SideMenuBar
    }
}
</script>

<style lang="scss" scoped>
.home-wrap {
    width: 100%;
    height: 100%;
}
</style>
